// Maps a solid Bootstrap badge variant to subtle Badge props.
//
// Instead of a saturated, high-contrast fill (e.g. bg="success"), this returns
// Bootstrap 5.3 subtle utilities (bg-*-subtle + text-*-emphasis + a matching
// subtle border) so status badges read quietly while keeping their semantic color.
// Spread the result onto a react-bootstrap <Badge>: <Badge {...subtleBadgeProps(v)} />.
const TONE: Record<string, string> = {
    primary: "primary",
    secondary: "secondary",
    success: "success",
    danger: "danger",
    warning: "warning",
    info: "info",
    dark: "dark",
    // light-subtle is near-white and unreadable as a status; fall back to secondary.
    light: "secondary",
};

export function subtleBadgeProps(
    variant: string,
    extraClassName?: string
): { bg: string; className: string } {
    const tone = TONE[variant] ?? "secondary";
    const base = `text-${tone}-emphasis border border-${tone}-subtle`;
    return {
        bg: `${tone}-subtle`,
        className: extraClassName ? `${base} ${extraClassName}` : base,
    };
}
